/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";
import { Link } from "react-router-dom";
import L from "../Lang";
import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Icon from "../Icon";

const menuItems = [
    { to: '/lab/location', icon: 'faBuilding', title: 'Lab Locations', description: 'Manage laboratory sites and locations.' },
    { to: '/productline/list', icon: 'faPuzzlePiece', title: 'Product Lines', description: 'Organize laboratory product lines.' },
    { to: '/panel/manage/list', icon: 'faVirus', title: 'Panels', description: 'Configure laboratory test panels.' },
    { to: '/target/manage/list', icon: 'faBullseye', title: 'Targets', description: 'Manage the targets included in your panels.' },
    { to: '/specimentype/list', icon: 'faFlaskVial', title: 'Specimen Types', description: 'Define the types of specimens your lab accepts.' },
    { to: '/report-template/list', icon: 'faPenNib', title: 'Report Templates', description: 'Manage templates for laboratory reports.' },
    { to: '/rule/list', icon: 'faTachographDigital', title: 'Rules', description: 'Configure laboratory rules.' }
];

const menuGroups = [
    { id: 'panels-products', title: 'Products & Compendium', items: menuItems.filter(item => ['/panel/manage/list', '/target/manage/list', '/productline/list'].includes(item.to)) },
    { id: 'lab-settings', title: 'Laboratory Settings', items: menuItems.filter(item => !['/panel/manage/list', '/target/manage/list', '/productline/list'].includes(item.to)) }
];


class LabManagerMenuItem extends React.Component {
    render() {
        return <li>
            <Link to={this.props.to} className="u-item">
                <span className="u-icon" aria-hidden="true"><Icon icon={this.props.icon} /></span>
                <span className="u-copy">
                    <span className="u-item-title"><L>{this.props.title}</L></span>
                    <span className="u-description"><L>{this.props.description}</L></span>
                </span>
                <span className="u-arrow" aria-hidden="true">→</span>
            </Link>
        </li>;
    }
}

class LabManager extends BaseCom {
    render() {
        return <div className="u-page container-fluid">
            <header className="u-header">
                <h1 role="heading" aria-level="1"><L>Lab Management</L></h1>
                <div className="u-eyebrow"><L>Configuration</L></div>
                <p className="u-intro"><L>Manage your laboratory setup, test panels, and reporting.</L></p>
            </header>
            <nav aria-label="Lab Management">
                {menuGroups.map(group => <section className="u-group" key={group.id} aria-labelledby={`u-${group.id}`}>
                    <div id={`u-${group.id}`} className="u-group-title" role="heading" aria-level="2"><L>{group.title}</L></div>
                    <ul className="u-grid">
                        {group.items.map(item => <LabManagerMenuItem key={item.to} {...item} />)}
                    </ul>
                </section>)}
            </nav>
        </div>;
    }
}

export default withParamsAndNavigate(LabManager);
